"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MurderedByCrowsAbilityHandler = exports.MurderedByCrowsActorAbilityFactory = exports.MurderedByCrowsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
class MurderedByCrowsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MurderedByCrows;
        this.__typeName = "MurderedByCrows";
    }
}
exports.MurderedByCrowsAbilityArgs = MurderedByCrowsAbilityArgs;
let MurderedByCrowsActorAbilityFactory = class MurderedByCrowsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MurderedByCrows", "AllEnemies", 4);
    }
};
MurderedByCrowsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MurderedByCrows")
], MurderedByCrowsActorAbilityFactory);
exports.MurderedByCrowsActorAbilityFactory = MurderedByCrowsActorAbilityFactory;
let MurderedByCrowsAbilityHandler = class MurderedByCrowsAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const { applyCameraVfx, resetCameraVfx } = core_2.CameraVfxStepArgs.mkSequencesFor(core_2.CameraVfxStepArgs.Alpha(.5));
        sequence.push(applyCameraVfx.mk());
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(enemy => ({
                targetId: enemy,
                jitter: (0, Random_1.random)(200, 500),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 90)
                ],
                effects: [
                    (0, Random_1.randomElement)([
                        {
                            targetId: enemy,
                            duration: Duration_1.Duration.Turns(4),
                            effect: new core_1.DarknessEffectArgs(2)
                        },
                        {
                            targetId: enemy,
                            duration: Duration_1.Duration.Turns(5),
                            effect: new core_1.VulnerabilityEffectArgs(2)
                        }
                    ])
                ],
            })),
            onHitOrMiss: (sequence, { targetId }, { hit }) => sequence.push(new core_2.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet") :
                LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "CrowStorm")),
            onCompleted: sequence => sequence.push(resetCameraVfx.mk())
        });
    }
};
MurderedByCrowsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MurderedByCrows)
], MurderedByCrowsAbilityHandler);
exports.MurderedByCrowsAbilityHandler = MurderedByCrowsAbilityHandler;
